module.exports = (RESTService) ->
  'ngInject'
  RESTService.setFullResponse(true).service('admin/client_versions')

